import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import loginActions from "../../redux/login/actions";
import { getSessionConfig, RoutesConfigsIDs } from "../../utils/session-helper";
import { LinksWrapper, NavWrappper, TituloMenu } from "./styled";

function MenuCooperado({ id }: { id?: string }) {
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [configs] = useState(getSessionConfig().Configuracoes);
  const [mostrarMenu, setMostrarMenu] = useState(false);

  const handleLogout = () => {
    dispatch(loginActions.logout());
    navigate("/");
  };

  return (
    <NavWrappper id={id}>
      <TituloMenu onClick={() => setMostrarMenu(!mostrarMenu)}>
        Menu do Cooperado
      </TituloMenu>

      <LinksWrapper className={mostrarMenu ? "mostrar" : ""}>
        {configs &&
          configs.map(
            (conf) =>
              conf.ID >= 5000 &&
              conf.ID !== 5006 &&
              conf.Valor !== "0" &&
              RoutesConfigsIDs[conf.ID] && (
                <Link to={RoutesConfigsIDs[conf.ID]} key={conf.ID}>
                  <li
                    className={
                      location.pathname === RoutesConfigsIDs[conf.ID]
                        ? "ativo"
                        : ""
                    }
                    key={conf.ID}
                  >
                    {conf.Descricao}
                  </li>
                </Link>
              )
          )}
        <li key="0.7" onClick={handleLogout}>
          SAIR
        </li>
      </LinksWrapper>
    </NavWrappper>
  );
}

export default MenuCooperado;
